import { render, staticRenderFns } from "./wtSelectProgrammer.component.vue?vue&type=template&id=6225217b&"
import script from "./wtSelectProgrammer.component.vue?vue&type=script&lang=js&"
export * from "./wtSelectProgrammer.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports